import { computed, makeAutoObservable } from 'mobx';

const ONE_HOUR_SEC = 3600;

export class CountdownTimer {
    totalTime: number;
    timeRemaining: number = 0;

    constructor(end: Date) {
        makeAutoObservable(this, {
            totalTime: false,
            hours: computed,
            minutes: computed,
            seconds: computed
        });

        const now = new Date();
        this.totalTime = (end.getTime() - now.getTime()) / 1000;
        this.timeRemaining = this.totalTime;
    }

    get hours() {
        return Math.floor(this.timeRemaining / ONE_HOUR_SEC);
    }

    get minutes() {
        return Math.floor(this.timeRemaining % ONE_HOUR_SEC / 60);
    }

    get seconds() {
        return Math.floor(this.timeRemaining % ONE_HOUR_SEC % 60);
    }

    start() {
        this.tick();
        setInterval(() => {
            this.tick();
        }, 1000);
    }

    tick() {
        this.timeRemaining--;
    }
}